module.exports = __webpack_public_path__ + "static/map.0050cd91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/map.jpg
// module id = 566
// module chunks = 70144966829960